import React, { useContext, useEffect, useState } from 'react';
import { GlobalSiteDataContext } from '../context';
import { StateHero, OurStateStores, SEO } from '../components';
import { graphql } from 'gatsby';

function StateTemplate({ pageContext }) {
  const { milanStores, milanOpenStores } = useContext(GlobalSiteDataContext);
  const [currentState, setCurrentState] = useState(null);

  useEffect(() => {
    if (milanStores.length > 0)
      setCurrentState(
        milanStores.find((state) => state.name === pageContext.state)
      );
  }, [milanStores.length]);

  return (
    <main id={`${pageContext.state}-page`} className='state-template'>
      <StateHero
        state={pageContext.state}
        countToDisplay={milanOpenStores.countToDisplay}
      />
      {currentState && (
        <OurStateStores currentState={currentState} milanStores={milanStores} />
      )}
    </main>
  );
}

export const Head = ({ data, location, pageContext }) => {
  const query = data.site.siteMetadata;
  return (
    <SEO
      location={location}
      origin={query.siteUrl}
      title={`${query.vertical} ${pageContext.state} locations`}
      // description={`${query.vertical} locations in ${pageContext.state}`} />
      description={`Find the best laser hair removal in ${pageContext.state} at one of Milan Laser's premier locations. Say hello to silky smooth skin today!`}
    />
  );
};

export const query = graphql`
  {
    site {
      siteMetadata {
        siteUrl
        umbrella
        vertical
        service
        title
      }
    }
  }
`;

export default StateTemplate;
